import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/nightOwl";

const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

const Button = (props) => (
  <button
    style={{
      border: "none",
      boxShadow: "none",
      textDecoration: "none",
      position: "absolute",
      top: 0,
      right: 0,
      margin: "8px",
      padding: "8px 12px",
      background: "#E2E8F022",
      borderRadius: "8px",
      cursor: "pointer",
      color: "#E2E8F0",
      fontSize: "14px",
      fontFamily: "sans-serif",
      lineHeight: "1",
    }}
    {...props}
  />
);

export const Code = ({ codeString, language, ...props }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  return (
    <div className="relative">
      <Highlight
        {...defaultProps}
        code={codeString}
        language={language}
        theme={theme}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={className} style={{ ...style, padding: "20px" }}>
            <Button
              className="focus:outline-none"
              onClick={() => {
                copyToClipboard(codeString);
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 5000);
              }}
            >
              {isCopied ? "🎉 Copied!" : "Copy"}
            </Button>
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  );
};
